export const environment = {
  production: false,
  apiServer: 'https://dev.api.tantumpay.com',
  authServer: 'https://dev.api.tantumpay.com',
  pxlApiServer: 'https://ident-stage-tnt.pxl-vision.com',
  pxlOiUrl: 'dev-identity.tantumpay.com',
  // captcha_key: "6LfCDw4mAAAAAJ6GwTiL12gGPYv11eINEAjVkBgZ" // prod
  captcha_key: "6LejCvUrAAAAAEtiXHdw9IqgsG5aFeKxtm0tsr70"
};